<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Rakan Brahedni is a technologist, futurist, certified health coach, and father-of-two on a mission to inspire others to live more mindful and meaningful lives with the hope of building a better world for future generations. He and his family reside in Dubai where he is currently working on his second book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0973643c